import React from 'react'
import { isAdmin } from '@cpsy-rmap-project/web-core/utils'
import AppBar from '@material-ui/core/AppBar'
import Avatar from '@material-ui/core/Avatar'
import Box from '@material-ui/core/Box'
import Icon from '@material-ui/core/Icon'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import { makeStyles } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import withWidth, { isWidthDown, WithWidthProps } from '@material-ui/core/withWidth'
import MenuIcon from '@material-ui/icons/Menu'
import { useHistory, useLocation } from 'react-router-dom'
import { Routes } from '../../../consts'
import HeaderSearch from '../../molecules/HeaderSearch'
import { useLogin } from '../Login'

const drawerWidth = 240

const useStyles = makeStyles(theme => ({
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth
  },
  appBarNoDrawer: {
    width: '100%',
    marginLeft: 0
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginRight: theme.spacing(2)
  }
}))

const menuId = 'profile-menu'

interface Props {
  openSider: boolean
  setOpenSider: React.Dispatch<React.SetStateAction<boolean>>
}

const Component: React.FC<Props & WithWidthProps> = ({ width, openSider, setOpenSider }) => {
  const login = useLogin()
  const location = useLocation()
  const isSiderHide = location.pathname === Routes.Search.path || (width && isWidthDown('sm', width))
  const classes = useStyles()
  const history = useHistory()
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    login.logout()
    handleMenuClose()
  }

  return (
    <>
      <AppBar position="fixed" className={isSiderHide ? classes.appBarNoDrawer : classes.appBar}>
        <Toolbar>
          {isSiderHide && (
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={() => setOpenSider(!openSider)}
              edge="start"
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
          )}
          <Box
            style={{ display: 'flex', cursor: 'pointer' }}
            onClick={() => {
              history.push(Routes.Home.path)
            }}
          >
            <Box>
              <img alt="logo" src="/images/icon.svg" height="36px" />
            </Box>
            <Box style={{ marginLeft: '6px', marginTop: '10px' }}>
              <Typography variant="h1" noWrap style={{ fontSize: '20px' }}>
                <span>CPSYMAP</span>
              </Typography>
            </Box>
          </Box>
          <div className={classes.grow} />
          {width && !isWidthDown('xs', width) && <HeaderSearch />}
          <IconButton
            disabled={!login.isLoggedIn()}
            edge="end"
            aria-label="account of current user"
            aria-controls={menuId}
            aria-haspopup="true"
            onClick={handleProfileMenuOpen}
            color="inherit"
          >
            {login.isLoggedIn() && login.fbUser ? (
              <Avatar src={login.fbUser.photoURL || undefined} style={{ width: '30px', height: '30px' }} />
            ) : (
              <Icon style={{ width: '30px', height: '30px' }} />
            )}
          </IconButton>
        </Toolbar>
      </AppBar>

      <Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isMenuOpen}
        onClose={handleMenuClose}
      >
        <MenuItem
          onClick={() => {
            history.push(Routes.Account.path)
            handleMenuClose()
          }}
        >
          Account
        </MenuItem>
        {isAdmin({ fbUser: login.fbUser }) && (
          <MenuItem
            onClick={() => {
              history.push(Routes.Admin.path)
              handleMenuClose()
            }}
          >
            ⚠ Admin
          </MenuItem>
        )}
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  )
}

export default withWidth()(Component)
